import {
  ADD_CHAT_OPENED_COUNT,
  CLOSE_SUBSCRIBE_POPUP,
  OPEN_SUBSCRIBE_POPUP,
  RECEIVE_ARTICLES,
  RECEIVE_EVENTS,
  RECEIVE_PAGE,
  RECEIVE_SITE,
  RECEIVE_WORKS,
  REQUEST_ARTICLES,
  REQUEST_EVENTS,
  REQUEST_PAGE,
  REQUEST_SITE, REQUEST_SITE_ERROR,
  REQUEST_WORKS,
} from './actions';
import {combineReducers} from 'redux'
import {reducer as formReducer} from 'redux-form';


function events(state = {isFetching: false}, action) {
  switch (action.type) {
    case REQUEST_EVENTS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_EVENTS:
      return {
        ...state,
        isFetching: false,
        items: action.items
      };
    default:
      return state;
  }
}

function works(state = {}, action) {
  switch (action.type) {
    case REQUEST_WORKS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_WORKS:
      return {
        ...state,
        isFetching: false,
        items: action.items
      };
    default:
      return state;
  }
}


function pages(state = {}, action) {
  switch (action.type) {
    case REQUEST_PAGE:
      return {
        ...state,
        [action.page]: {
          isFetching: true,
        }
      };
    case RECEIVE_PAGE:
      return {
        ...state,
        [action.page]: {
          isFetching: false,
          doc: action.doc
        }
      };
    default:
      return state;
  }
}

function site(state = null, action) {
  switch (action.type) {
    case REQUEST_SITE:
      return {
        isFetching: true,
      };
    case RECEIVE_SITE:
      return {
        item: action.site,
        isFetching: false,
      };
    case REQUEST_SITE_ERROR:
      return {
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
}

function articles(state = {}, action) {
  switch (action.type) {
    case REQUEST_ARTICLES:
      return {
        ...state,
        isFetching: true
      };
    case RECEIVE_ARTICLES:
      return {
        ...state,
        isFetching: false,
        items: action.items
      };
    default:
      return state;
  }
}

function subscribePopup(state = {}, action) {
  switch(action.type) {
    case OPEN_SUBSCRIBE_POPUP:
      return {
        ...state,
        open: true,
      };
    case CLOSE_SUBSCRIBE_POPUP:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
}

function chatOpenedCount(state = 0, action) {
  switch(action.type) {
    case ADD_CHAT_OPENED_COUNT:
      return state + 1;
    default:
      return state;
  }
}

const website = combineReducers({
  pages,
  site,
  form: formReducer,
  works,
  articles,
  subscribePopup,
  chatOpenedCount,
});

export default website;



// WEBPACK FOOTER //
// ./src/redux/reducers.js